import React, { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import Api from '../../api/global.service';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import FormInput from '../../nuup/componentes/Forms/FormInput.jsx';
import { Link, useParams } from 'react-router-dom';
import { Panel, PanelBody } from '../../components/panel/panel.jsx';
import BlockUi from 'react-block-ui';
import Swal from 'sweetalert2';
import FormSelectMaterial from '../../nuup/componentes/Forms/FormSelectMaterial.jsx';

const sharedNameForm = 'Cooperativas';
const sharedTable = 'cooperativas';
const sharedURL = '/admin/cooperativas/list';

const CooperativasCRUD = () => {
  const { uuid } = useParams();
  const [name] = useState('Cooperativas');
  const [nameForm] = useState(sharedNameForm);
  const [table] = useState(sharedTable);
  const [url] = useState(sharedURL);
  const [blocking, setBlocking] = useState(false);
  const [paises, setPaises] = useState([]);
  const schema = yup.object().shape({
    nombre: yup.string().required('Nombre es requerido'),
    iniciales: yup.string().max(2, 'Máximo 2 caracteres'),
    producto: yup.number().required('Producto es requerido'),
    paises: yup
      .array()
      .of(yup.string())
      .required('Países es requerido'),
  });

  const {
    register,
    handleSubmit,
    reset,
    watch,
    setValue,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    mode: 'onBlur',
    defaultValues: {
      nombre: '',
      iniciales: '',
      descripcion: '',
      producto: 1,
      paises: [1],
      cuenta_kobo: '',
      certificacion: '',
      ubicacion: '',
      nombre_legal: '',
      direccion: '',
      rfc: '',
      contacto: '',
      flo_id: '',
    },
  });

  const getPaises = () => {
    Api.getAll('paises').then(response => {
      let items = response.data.map(function(item) {
        return { value: item['id'], label: item['nombre'] };
      });
      setPaises(items);
    });
  };

  useEffect(() => {
    if (uuid != null) {
      setBlocking(true);
      Api.get(table, uuid)
        .then(response => {
          reset(response.data[0]);
          setBlocking(false);
        })
        .catch(e => {
          // eslint-disable-next-line no-console
          console.log('e', e);
          setBlocking(false);
        });
    }
    getPaises();
  }, []);

  const onSubmit = values => {
    var item = {
      nombre: values.nombre,
      iniciales: values.iniciales,
      descripcion: values.descripcion,
      id_cat_productos: values.producto,
      selected_paises: values.paises,
      cuenta_kobo: values.cuenta_kobo,
      certificacion: values.certificacion,
      ubicacion: values.ubicacion,
      nombre_legal: values.nombre_legal,
      direccion: values.direccion,
      rfc: values.rfc,
      contacto: values.contacto,
      flo_id: values.flo_id,
    };
    setBlocking(true);
    if (uuid == null) {
      //CREATE
      Api.create(table, item)
        .then(response => {
          setBlocking(false);
          Swal.fire({
            icon: 'success',
            title: `Se registró con éxito ${response.data.cooperativa.nombre}`,
            text: `Se le agregó la configuración por default. Revisa con el equipo de desarrollo para configuración extra.`,
            confirmButtonText: 'Continuar',
          }).then(result => {
            if (result.isConfirmed) {
              window.location.href = url;
            }
          });
        })
        .catch(e => {
          setBlocking(false);
          Swal.fire({
            icon: 'error',
            title: '',
            text: e,
          });
        });
    } else {
      //EDIT
      Api.update(table, uuid, item)
        .then(response => {
          let data = response.data[0];
          setBlocking(false);
          Swal.fire({
            icon: 'success',
            title: '',
            text: `Se actualizó con éxito la ${nameForm.toLowerCase()} -> ${data.uuid}`,
          });
          window.location.href = url;
        })
        .catch(e => {
          setBlocking(false);
          Swal.fire({
            icon: 'error',
            title: '',
            text: e,
          });
        });
    }
  };

  return (
    <>
      <div className="row justify-content-between">
        <h1 className="page-header">
          {name} / {uuid == null ? 'Nuevo' : 'Editar'}
        </h1>
        <Link to={{ pathname: `/admin/cooperativas/list` }} style={{ marginTop: '-26px' }}>
          <button type="button" className="btn btn-outline-secondary mt-4" style={{ borderRadius: '20px 20px 20px 20px' }}>
            <i className="fa fa-arrow-left"></i> Volver a Cooperativas
          </button>
        </Link>
      </div>

      <div className="row">
        <div className="col-md-12">
          <Panel>
            <PanelBody>
              <BlockUi tag="div" message="" blocking={blocking} renderChildren={true}>
                <form onSubmit={handleSubmit(onSubmit)}>
                  <div className="row">
                    <div className="col-md-12 mb-3">
                      <FormInput id="uuid" type="hidden" name="uuid" label="UUID" error={errors.uuid} register={register} required />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12 mb-3">
                      <FormInput id="nombre" type="text" name="nombre" label="Nombre*" error={errors.nombre} register={register} />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12 mb-3">
                      <FormInput
                        id="iniciales"
                        type="text"
                        name="iniciales"
                        label="Iniciales*"
                        error={errors.iniciales}
                        register={register}
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12 mb-3">
                      <FormInput
                        id="descripcion"
                        type="text"
                        name="descripcion"
                        label="Descripción"
                        error={errors.descripcion}
                        register={register}
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-xl-3 col-lg-6 mb-3">
                      <FormSelectMaterial
                        id="producto"
                        error={Boolean(errors.producto)}
                        label="Producto*"
                        value={watch('producto')}
                        onChange={val => setValue('producto', val)}
                        height={30}
                        options={[
                          { value: 1, label: 'Café' },
                          { value: 2, label: 'Cacao' },
                          { value: 3, label: 'Miel' },
                        ]}
                      />
                      {errors.producto && <div className="text-danger small mt-1">{errors.producto.message}</div>}
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-xl-3 col-lg-6 mb-3">
                      <FormSelectMaterial
                        id="paises"
                        name="paises"
                        label="Países*"
                        multiple={true}
                        error={errors.paises}
                        register={register}
                        url="paises"
                        options={paises}
                        value={watch('paises')}
                        onChange={val => setValue('paises', val)}
                      />
                    </div>
                  </div>
                  {/* <div className="row">
                    <div className="col-md-12 mb-3">
                      <FormInput id="logo" type="text" name="logo" label="Logo" error={errors.logo} register={register} />
                    </div>
                  </div> */}
                  <div className="row">
                    <div className="col-md-12 mb-3">
                      <FormInput
                        id="cuenta_kobo"
                        type="text"
                        name="cuenta_kobo"
                        label="Cuenta Kobo"
                        error={errors.cuenta_kobo}
                        register={register}
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12 mb-3">
                      <FormInput
                        id="certificacion"
                        type="text"
                        name="certificacion"
                        label="Certificación"
                        error={errors.certificacion}
                        register={register}
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12 mb-3">
                      <FormInput
                        id="ubicacion"
                        type="text"
                        placeholder="Mpio, Estado, País (opcional)"
                        name="ubicacion"
                        label="Ubicación"
                        error={errors.ubicacion}
                        register={register}
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12 mb-3">
                      <FormInput
                        id="nombre_legal"
                        type="text"
                        placeholder="Nombre legal"
                        name="nombre_legal"
                        label="Nombre legal"
                        error={errors.nombre_legal}
                        register={register}
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12 mb-3">
                      <FormInput
                        id="direccion"
                        type="text"
                        name="direccion"
                        label="Dirección"
                        placeholder="Calle, número, colonia, municipio"
                        error={errors.direccion}
                        register={register}
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12 mb-3">
                      <FormInput
                        id="rfc"
                        type="text"
                        name="rfc"
                        label="RFC"
                        placeholder="XXX000000XXX"
                        error={errors.rfc}
                        register={register}
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12 mb-3">
                      <FormInput
                        id="contacto"
                        type="text"
                        name="contacto"
                        label="Correo de contacto"
                        placeholder="responsable@organizacion.com"
                        error={errors.contacto}
                        register={register}
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12 mb-3">
                      <FormInput
                        id="flo_id"
                        type="text"
                        placeholder="12345"
                        name="flo_id"
                        label="Flo ID"
                        error={errors.flo_id}
                        register={register}
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-3 offset-md-9">
                      <button className="btn btn-primary btn-block" type="submit">
                        Guardar
                      </button>
                    </div>
                  </div>
                </form>
              </BlockUi>
            </PanelBody>
          </Panel>
        </div>
      </div>
    </>
  );
};

export function deleteByUUID(uuid) {
  //DELETE
  Swal.fire({
    title: '¿Esta seguro?',
    text: 'El registro se eliminará',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    confirmButtonText: 'Si, eliminar!',
  }).then(result => {
    if (result.isConfirmed) {
      Api.delete(sharedTable, uuid)
        .then(() => {
          Swal.close();
          Swal.fire({
            icon: 'success',
            title: '',
            text: 'Se eliminó con exito el cooperativa -> ' + uuid,
          });
          window.location.href = sharedURL;
        })
        .catch(e => {
          Swal.fire({
            icon: 'error',
            title: '',
            text: e,
          });
        });
    }
  });
}

export default CooperativasCRUD;
